import api from './api';
import { Appointment, PaginatedResponse } from '../types';

export const appointmentService = {
  async getAll(params?: {
    dentistId?: string;
    patientId?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
    page?: number;
    limit?: number;
  }): Promise<PaginatedResponse<Appointment>> {
    const response = await api.get('/appointments', { params });
    return response.data;
  },

  async getById(id: string): Promise<Appointment> {
    const response = await api.get(`/appointments/${id}`);
    return response.data;
  },

  async getByDate(date: string, dentistId?: string): Promise<Appointment[]> {
    const response = await api.get('/appointments/by-date', {
      params: { date, dentistId },
    });
    return response.data;
  },

  async getAvailableSlots(dentistId: string, date: string): Promise<string[]> {
    const response = await api.get('/appointments/available-slots', {
      params: { dentistId, date },
    });
    return response.data;
  },

  async create(data: Partial<Appointment>): Promise<Appointment> {
    const response = await api.post('/appointments', data);
    return response.data;
  },

  async update(id: string, data: Partial<Appointment>): Promise<Appointment> {
    const response = await api.patch(`/appointments/${id}`, data);
    return response.data;
  },

  async reschedule(
    id: string,
    data: { dateTime: string; duration?: number }
  ): Promise<Appointment> {
    const response = await api.patch(`/appointments/${id}/reschedule`, data);
    return response.data;
  },

  async confirm(id: string): Promise<Appointment> {
    const response = await api.patch(`/appointments/${id}/confirm`);
    return response.data;
  },

  async complete(
    id: string,
    data: { notes?: string; diagnosis?: string }
  ): Promise<Appointment> {
    const response = await api.patch(`/appointments/${id}/complete`, data);
    return response.data;
  },

  async cancel(id: string, reason?: string): Promise<Appointment> {
    const response = await api.delete(`/appointments/${id}`, {
      data: { reason },
    });
    return response.data;
  },
};
